import { render, staticRenderFns } from "./prod-table.vue?vue&type=template&id=4d8508f6&scoped=true&"
import script from "./prod-table.vue?vue&type=script&lang=js&"
export * from "./prod-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8508f6",
  null
  
)

export default component.exports